import { heroStats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="top" className="w-full border-b border-background-200/70 bg-background-100/70">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-10 px-4 py-12 md:px-8 md:py-16 lg:grid-cols-2 lg:gap-14">
        <div className="fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-label text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inset-0 rounded-full bg-primary-500/40 marching-bar"></span>
              <span className="relative h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            今日已更新 12 条新入口
          </span>

          <h2 className="mt-5 font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-950 md:text-[2.65rem]">
            黑料网站入口与地址
            <br />
            <span className="text-primary-600">备用 · 镜像</span> 一站式汇总
          </h2>

          <p className="mt-5 max-w-xl text-sm leading-7 text-foreground-700 md:text-base">
            这里整理黑料网站入口、地址、备用与镜像链接，换链接防走丢一手掌握。经常打不开或找不到新网址的，直接收藏本页，随时回来刷新，不用再到处问人。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#entries"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-flashlight-fill text-base" aria-hidden="true"></i>
              </span>
              查看最新可用入口
            </a>
            <a
              href="#mirrors"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-label font-medium text-foreground-800 transition-colors hover:border-secondary-300 hover:text-secondary-700"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-bookmark-line text-base" aria-hidden="true"></i>
              </span>
              收藏本页 / 看镜像
            </a>
          </div>

          <dl className="mt-9 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-300/70 pt-7 sm:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.id}>
                <dd className="flex items-baseline gap-1">
                  <span className="font-heading text-2xl font-bold text-foreground-950">{stat.value}</span>
                  <span className="text-xs font-label text-foreground-500">{stat.unit}</span>
                </dd>
                <dt className="mt-1 text-xs font-label text-foreground-600">{stat.label}</dt>
              </div>
            ))}
          </dl>
        </div>

        <div className="fade-up">
          <div className="relative">
            <div className="h-[340px] w-full overflow-hidden rounded-lg border border-background-200 md:h-[420px] lg:h-[480px]">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20warm-toned%20editorial%20illustration%20of%20a%20modern%20information%20portal%2C%20layered%20modular%20content%20cards%20connected%20by%20thin%20network%20lines%2C%20deep%20crimson%20and%20amber%20accents%20over%20a%20soft%20cream%20background%2C%20clean%20minimalist%20geometric%20composition%2C%20subtle%20paper%20grain%20texture%2C%20high%20detail%2C%20restrained%20and%20elegant%20design%20aesthetic&width=1000&height=1200&seq=hailiao-hero-01&orientation=portrait"
                alt="黑料网站入口与镜像汇总可视化示意"
                title="黑料网站入口 地址 备用 镜像汇总"
                className="h-full w-full object-cover object-top"
              />
            </div>

            <div className="mt-4 flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className="ri-pulse-line text-xl" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="text-sm font-label font-medium text-foreground-950">线路实时巡检中</p>
                  <p className="mt-0.5 text-xs font-label text-foreground-500">
                    {`最近一次巡检 · 3 分钟前`}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="text-right">
                  <p className="font-heading text-lg font-bold text-primary-600">42</p>
                  <p className="text-[11px] font-label text-foreground-500">在线线路</p>
                </div>
                <span className="h-8 w-px bg-background-200"></span>
                <div className="text-right">
                  <p className="font-heading text-lg font-bold text-accent-600">99.6%</p>
                  <p className="text-[11px] font-label text-foreground-500">可用率</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}